import React from 'react';
import { Reveal } from '../Reveal';
import { DownloadIcon } from 'lucide-react';
import { cvHref, profile, socialLinks } from '../../data/profile';
export function ContactCTA() {
  return <section id="contact" className="mt-28 scroll-mt-24 lg:scroll-mt-10" data-id="element-172" data-mp="3pmnydejvevf5">
      <Reveal data-id="element-173" data-mp="3pnyxv26a9h0g">
        <div className="rounded-3xl bg-ink px-6 py-12 text-white md:px-12 md:py-16" data-id="element-174" data-mp="3kvnzi3r6y3a0">
          <h2 className="max-w-lg text-3xl font-semibold leading-tight tracking-tight md:text-[40px]" data-id="element-175" data-mp="3exsv4j63q5x">
            Have a product people start but don't finish?
          </h2>
          <p className="mt-4 max-w-md text-[15px] leading-relaxed text-white/75" data-id="element-176" data-mp="3ukz3xd34ujrk">
            I'm open to senior product design roles and projects in fintech, AI and SaaS.
          </p>
          <div className="mt-8 flex flex-wrap gap-3" data-id="element-177" data-mp="8eiqnbmlpsh2">
            <a href={`mailto:${profile.email}`} className="rounded-full bg-white px-5 py-2.5 text-sm font-medium text-ink transition-transform duration-150 ease-out hover:-translate-y-px active:scale-[0.97]" data-id="element-178" data-mp="2e6fqcxlo6rw3">
              Email me
            </a>
            <a href={cvHref} target={profile.cv ? '_blank' : undefined} rel="noreferrer" className="inline-flex items-center gap-2 rounded-full border border-white/30 px-5 py-2.5 text-sm font-medium text-white transition-[border-color,transform] duration-150 ease-out hover:border-white/70 active:scale-[0.97]" data-id="element-179" data-mp="3di2xzlvg8jv8">
              <DownloadIcon className="h-4 w-4" aria-hidden data-id="element-180" data-mp="3s9l8x59gbo7q" />
              Download CV
            </a>
            {socialLinks.filter(l => l.label !== 'Medium').map(link => <a key={link.label} href={link.href} target="_blank" rel="noreferrer" className="rounded-full border border-white/30 px-5 py-2.5 text-sm font-medium text-white transition-[border-color,transform] duration-150 ease-out hover:border-white/70 active:scale-[0.97]" data-id="element-181" data-mp="a1dpvvg7x23g">
                  {link.label}
                </a>)}
          </div>
        </div>
      </Reveal>
    </section>;
}